import { Box } from "@mui/material";
import { useState } from "react";

const UserImage = ({ image, size = "60px", verified }) => {
  const [imageError, setImageError] = useState(false);
  
  const handleImageError = () => {
    setImageError(true);
  };

  // Default avatar as a data URL (gray circle)
  const defaultAvatar = `data:image/svg+xml;base64,${btoa(`
    <svg width="60" height="60" viewBox="0 0 60 60" fill="none" xmlns="http://www.w3.org/2000/svg">
      <circle cx="30" cy="30" r="30" fill="#cccccc"/>
      <circle cx="30" cy="24" r="10" fill="#999999"/>
      <path d="M10 50c0-11 9-20 20-20s20 9 20 20" fill="#999999"/>
    </svg>
  `)}`;

  return (
    <Box width={size} height={size} position="relative">
      <img
        style={{ objectFit: "cover", borderRadius: "30%" }}
        width={size}
        height={size}
        alt="user"
        src={imageError ? defaultAvatar : image}
        onError={handleImageError}
      />
      {verified && 
        <img
          src="/assets/badges/verified.svg"
          alt="Verified Badge"
          style={{ 
            width: "1.2rem", 
            position: "absolute", 
            bottom: 0, 
            right: 0 
          }}
        />
      }
    </Box>
  );
};

export default UserImage;